import React from 'react';
import PropTypes from 'prop-types';
import { Image } from './styles';

const RemoveButton = ({
  disabled,
  onClick,
  isEdit,
}) => (
  <Image
    onClick={!disabled && onClick}
    src={disabled ? '/images/cross-icon-disabled.png' : '/images/cross-icon.png'}
    alt="Remove"
    isEdit={isEdit}
  />
);

RemoveButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
};

RemoveButton.defaultProps = {
  disabled: false,
  isEdit: false,
};

export default RemoveButton;
